export const environment  = {
  production: false,
  firestoreUrl: `https://firestore.googleapis.com/v1/projects/bashan-foundation/databases/(default)/documents`,
  firebaseInitializationConfig : {
    "projectId":"bashan-foundation",
    "appId":"1:690094889782:web:6cf5ad65eac0a9e7493197",
    "storageBucket":"bashan-foundation.appspot.com",
    // "locationId":"us-east4",
    "apiKey":"AIzaSyBdjyBKQxWfLL8gwYVbtjCoE2U-M-8AeIQ",
    "authDomain":"bashan-foundation.firebaseapp.com",
    "messagingSenderId":"690094889782",
    "measurementId":"G-SZT879HGH5"
  }
};
